<strong>Fotos de {{mascota.ma_nombre}}</strong>
<p class="foto-ayuda">Arrastra las fotos para ordenarlas. La primera será la foto principal al pulsar Guardar.</p>
<p *ngIf="ordenCambiado" class="foto-aviso">Orden modificado. Pulsa <strong>Guardar</strong> para grabarlo.</p>
<div class="border rounded-4 p-3">
  <div class="galeria-ordenable">
    <div class="foto-item" *ngFor="let foto of mascota.previewUrl; let i = index"
         [attr.data-foto-indice]="i" [class.foto-borrada]="foto.borrada"
         [class.foto-arrastrada]="arrastrando === i"
         [class.foto-destino]="destinoArrastre === i && arrastrando !== i">
      <span class="etiqueta-principal" *ngIf="esPrincipal(i)"><i class="fa-solid fa-star"></i> Principal</span>
      <div class="foto-superficie" [class.no-arrastrable]="foto.borrada"
           (pointerdown)="iniciarArrastrePuntero($event, i)"
           (pointermove)="moverArrastrePuntero($event)"
           (pointerup)="soltarArrastrePuntero($event)"
           (pointercancel)="cancelarArrastrePuntero($event)"
           (lostpointercapture)="capturaPerdida($event)">
        <img [src]="foto.data || foto.url" [alt]="'Foto de '+(mascota.ma_nombre || 'mascota')"
             loading="lazy" [draggable]="false" [class.disabled-div]="foto.borrada">
        <span class="icono-arrastre" *ngIf="!foto.borrada" title="Arrastrar para ordenar"><i class="fa-solid fa-grip"></i></span>
      </div>
      <div class="acciones-foto">
        <button type="button" class="accion-foto" (click)="moverFoto(i,-1)" [disabled]="i===0 || foto.borrada" title="Mover a la izquierda"><i class="fa-solid fa-chevron-left"></i></button>
        <button type="button" class="accion-foto" (click)="moverFoto(i,1)" [disabled]="i===mascota.previewUrl.length-1 || foto.borrada" title="Mover a la derecha"><i class="fa-solid fa-chevron-right"></i></button>
        <button type="button" class="accion-foto borrar" (click)="borrarFoto(i)" [title]="foto.borrada ? 'Recuperar foto' : 'Eliminar foto'"><i class="fa-solid" [ngClass]="foto.borrada ? 'fa-arrow-rotate-left' : 'fa-trash'"></i></button>
      </div>
    </div>
    <button type="button" class="add-photo-box" *ngIf="numeroFotosActivas()<5" (click)="onClickImagen()" title="Añadir fotos">
      <i class="fa-regular fa-camera fs-3"></i><span>Añadir</span>
    </button>
  </div>
</div>
<input type="file" multiple #fileInputFotosMascota accept="image/*" hidden (change)="onFileSelected($event)">
